import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ErrorNotificationService } from '@core/error-handling/error-notification.service';

@Component({
  selector: 'app-error-toast',
  templateUrl: './error-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorToastComponent {
  protected readonly notifications = inject(ErrorNotificationService);
}
